import { createStyles, makeStyles, Theme, cardBoxShadow } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: 24,
  },
  container: {
    maxWidth: theme.space.singleColumnMaxWidth,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  riskItemWrapper: {
    padding: '24px 32px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8,
    cursor: 'pointer',
    border: `1px solid transparent`,
  },
  riskItemWrapperSelected: {
    border: `1px solid ${theme.color.oranges[100]}`,
    boxShadow: cardBoxShadow,
  },
  caption: {
    color: theme.color.greys[60],
    textAlign: 'left',
    marginTop: 24,
    marginBottom: 32,
  },
  button: {
    marginTop: 16,
    width: 'fit-content',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      alignSelf: 'stretch',
    },
  },
}), { name: 'ChooseRiskLevel' });
